import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ExternalLink = ({ href, country }) => {
  const { t } = useTranslation();
  return (
    <a href={href} target="_blank" rel="noreferrer">
      <Button variant="primary" size="sm" className="me-3">
        {t(`funnelFilters.${country}`)}
      </Button>
    </a>
  );
};
export default ExternalLink;
